/* Perf ago-2026: las imagenes hover de las tarjetas se emiten con
   data-src/data-srcset (ver product-grid-item.liquid) y solo se cargan al
   primer pointerover/focusin sobre la tarjeta. Global (como sibling-swatches)
   para cubrir home, colecciones y HTML inyectado por quick view / Section
   Rendering. En touch nunca dispara: HoverSlideshow ya hace bail y el overlay
   es display:none con .supports-touch. */
(function () {
  'use strict';
  if (window.__ukHoverDeferBound) return;
  window.__ukHoverDeferBound = true;

  function swap(block) {
    // Los <source> primero: el string-replace de product-grid-item tambien
    // renombra su srcset a data-srcset dentro de <picture>, y conviene que
    // esten vivos antes de fijar el src del <img> (evita doble descarga).
    block.querySelectorAll('[data-hover-slideshow-holder] source[data-srcset]').forEach(function (source) {
      source.setAttribute('srcset', source.getAttribute('data-srcset'));
      source.removeAttribute('data-srcset');
    });
    block.querySelectorAll('[data-hover-slideshow-holder] img[data-src]').forEach(function (img) {
      var ss = img.getAttribute('data-srcset');
      if (ss) {
        img.setAttribute('srcset', ss);
        img.removeAttribute('data-srcset');
      }
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    });
  }

  function onIntent(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var block = target.closest('[data-product-block]');
    if (!block || block.hasAttribute('data-hover-loaded')) return;
    // Marcar el bloque ya restaurado: los pointerover siguientes solo pagan
    // el hasAttribute, no los querySelectorAll de swap().
    block.setAttribute('data-hover-loaded', '');
    swap(block);
  }

  document.addEventListener('pointerover', onIntent, { passive: true, capture: true });
  document.addEventListener('focusin', onIntent, true);
})();
